// frontend/main.tsx
import { createRoot } from 'react-dom/client';
import AppWrapper from './AppWrapper';
import './styles/global.css'; // Import global CSS

createRoot(document.getElementById('root')!).render(<AppWrapper />);